import { render, staticRenderFns } from "./ConsultTabs.vue?vue&type=template&id=89808438&scoped=true&"
import script from "./ConsultTabs.vue?vue&type=script&lang=js&"
export * from "./ConsultTabs.vue?vue&type=script&lang=js&"
import style0 from "./ConsultTabs.vue?vue&type=style&index=0&id=89808438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89808438",
  null
  
)

export default component.exports